import React from 'react';
const usePassiveLayoutEffect = React[typeof document !== 'undefined' && document.createElement !== void 0 ? 'useLayoutEffect' : 'useEffect'];
export default usePassiveLayoutEffect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-hook/passive-layout-effect/dist/module/index.js
// module id = 481
// module chunks = 10